export default "/static/webpack/media/to-top.c72656c1.svg";